import styled from "styled-components"

export const Image = styled.img`
    width: ${props => props.width};
    height: ${props => props.height};
    object-fit: cover;
    border-radius: ${props => props.borderRadius};
    filter: ${props => props.filter};
`